import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { UpdateFormNameRequestActionType } from "../types";
import { FormsService } from "../../../services/forms";
import { createFormFailure } from "./../actionCreators";
import { IErrorType } from "./../../types/errors.d";

export function* updateFormNameSaga({ payload: { name } }: UpdateFormNameRequestActionType) {
    try {
        yield FormsService.newUpdateForm({ data: [{ name }] });
    } catch (error) {
        if (axios.isAxiosError(error))
            yield put(createFormFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(createFormFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
